<template>
	<aside class="aside-container">
		<div class="aside-inner">
			<nav class="sidebar" data-sidebar-anyclick-close="">
				<ul class="sidebar-nav">

					<userblock/>

					<li class="nav-heading">
						<span>{{ $t('sidebar.menu') }}</span>
					</li>

					<li :class="{'active': this.menu === 'tenders'}"
						v-if="is_administrator || is_contractor || is_supplier">
						<router-link :to="{name: 'tenders'}" :title="$t('sidebar.tenders')">
							<em class="icon-layers"></em>
							<span>{{ $t('sidebar.tenders') }}</span>
						</router-link>
					</li>

					<li :class="{'active': this.menu === 'details'}" v-if="is_administrator || is_contractor">
						<router-link :to="{name: 'details'}" :title="$t('sidebar.pre-orders')">
							<em class="icon-briefcase"></em>
							<span>{{ $t('sidebar.pre-orders') }}</span>
						</router-link>
					</li>

					<li class="nav-heading" v-if="is_administrator || is_contractor">
						<span>{{ $t('sidebar.reports') }}</span>
					</li>

					<li :class="{'active': this.menu === 'reports' && this.submenu === 'parts'}"
						v-if="is_administrator || is_contractor"
					>
						<router-link :to="{name: 'report_parts'}" :title="$t('sidebar.parts')">
							<em class="icon-rocket"></em>
							<span>{{ $t('sidebar.parts') }}</span>
						</router-link>
					</li>

					<li
							:class="{'active': this.menu === 'reports' && this.submenu === 'suppliers'}"
							v-if="is_administrator || is_contractor"
							@mouseover="suppliers_over"
					>
						<router-link :to="{name: 'report_suppliers'}" :title="$t('sidebar.suppliers')"
									 @mouseover="suppliers_over">
							<em class="icon-people" @mouseover="suppliers_over"></em>
							<span @mouseover="suppliers_over">{{ $t('sidebar.suppliers') }}</span>
						</router-link>
					</li>

					<li :class="{'active': this.menu === 'reports' && this.submenu === 'orders'}"
						v-if="is_administrator || is_contractor"
					>
						<router-link :to="{name: 'report_orders'}" :title="$t('sidebar.orders')">
							<em class="icon-bag"></em>
							<span>{{ $t('sidebar.orders') }}</span>
						</router-link>
					</li>

					<li :class="{'active': this.menu == 'productcatreport'}"
						v-if="is_administrator || is_contractor">
						<router-link :to="{name: 'admin_product_cat_report'}" :title="$t('sidebar.productcategory')">
							<em class="icon-shuffle"></em>
							<span>{{ $t('sidebar.productcategory') }}</span>
						</router-link>
					</li>


					<li :class="{'active': this.menu === 'reports' && this.submenu === 'consolidated'}"
						v-if="is_administrator">
						<router-link :to="{name: 'report_consolidated'}" :title="$t('sidebar.consolidated')">
							<em class="icon-calculator"></em>
							<span>{{ $t('sidebar.consolidated') }}</span>
						</router-link>
					</li>

					<li class="nav-heading" v-if="is_administrator || is_contractor">
						<span>{{ $t('sidebar.settings') }}</span>
					</li>
					<li :class="{'active': this.menu === 'setup'}" v-if="is_supplier && is_not_plain">
						<router-link :to="{path: '/supplier/'+supplierId+'/details'}"
									 :title="$t('sidebar.supplier-data')">
							<em class="icon-user-following"></em>
							<span>{{$t('sidebar.supplier-data')}}</span>
						</router-link>
					</li>
					<li
							:class="{'active': this.menu === 'setup', 'open': this.setup_active}"
							v-if="is_administrator || is_contractor">
						<a :title="$t('sidebar.setup')" @click="toggle_setup" @mouseover="setup_over">
							<em class="icon-exclamation" @mouseover="setup_over"></em>
							<span @mouseover="setup_over">{{ $t('sidebar.setup') }}</span>
						</a>

						<ul
								class="sidebar-nav sidebar-subnav collapse"
								:class="{'show': show_setup}"
								v-if="is_administrator || is_contractor">
							<li class="sidebar-subnav-header" :title="$t('sidebar.setup')">{{ $t('sidebar.setup') }}
							</li>

							<li :class="{'active': this.menu !== 'reports' && this.submenu === 'parts'}"
								v-if="is_administrator || is_contractor">
								<router-link :to="{name: 'parts'}" :title="$t('sidebar.parts')">
									<em class="fas fa-angle-right"></em>
									<span>{{ $t('sidebar.parts') }}</span>
								</router-link>
							</li>


							<li :class="{'active': this.submenu === 'parttypes'}"
								v-if="is_administrator || is_contractor">
								<router-link :to="{name: 'parttypes'}" :title="$t('sidebar.part-type')">
									<em class="fas fa-angle-right"></em>
									<span>{{ $t('sidebar.part-type') }}</span>
								</router-link>
							</li>

							<li :class="{'active': this.submenu === 'producers'}"
								v-if="is_administrator || is_supplier || is_contractor">
								<router-link :to="{name: 'producers'}" :title="$t('sidebar.producers')">
									<em class="fas fa-angle-right"></em>
									<span>{{ $t('sidebar.producers') }}</span>
								</router-link>
							</li>

							<li :class="{'active': this.submenu === 'blacklists'}"
								v-if="is_administrator || is_contractor">
								<router-link :to="{name: 'blacklists'}" :title="$t('sidebar.black-list')">
									<em class="fas fa-angle-right"></em>
									<span>{{ $t('sidebar.black-list') }}</span>
								</router-link>
							</li>

							<li :class="{'active': this.submenu === 'warehouses'}"
								v-if="is_administrator || is_contractor">
								<router-link :to="{name: 'warehouses'}" :title="$t('sidebar.warehouse-list')">
									<em class="fas fa-angle-right"></em>
									<span>{{ $t('sidebar.warehouse-list') }}</span>
								</router-link>
							</li>

							<li :class="{'active': this.submenu === 'groups'}" v-if="is_administrator || is_contractor">
								<router-link :to="{name: 'groups'}" :title="$t('sidebar.group-list')">
									<em class="fas fa-angle-right"></em>
									<span>{{ $t('sidebar.group-list') }}</span>
								</router-link>
							</li>

							<li :class="{'active': this.menu === 'productcat'}"
								v-if="is_administrator || is_contractor">
								<router-link :to="{name: 'admin_product_cat'}" title="$t('sidebar.categories')">
									<em class="fas fa-angle-right"></em>
									<span>{{ $t('sidebar.categories') }}</span>
								</router-link>
							</li>

              <li :class="{'active': this.menu === 'units'}"
                  v-if="is_administrator || is_supplier">
                <router-link :to="{name: 'units'}" title="$t('sidebar.units')">
                  <em class="fas fa-angle-right"></em>
                  <span>{{ $t('sidebar.units') }}</span>
                </router-link>
              </li>
						</ul>
					</li>

					<li
							:class="{'active': this.menu === 'users', 'open': this.users_active}"
							v-if="is_administrator || is_contractor"
					>
						<a :title="$t('sidebar.users')" @click="toggle_users" @mouseover="users_over">
							<em class="icon-user-following" @mouseover="users_over"></em>
							<span @mouseover="users_over">{{ $t('sidebar.users') }}</span>
						</a>

						<ul class="sidebar-nav sidebar-subnav collapse" :class="{'show': show_users}">
							<li class="sidebar-subnav-header">{{ $t('sidebar.users') }}</li>

							<li :class="{'active': this.submenu === 'workers'}" v-if="is_administrator">
								<router-link :to="{name: 'workers'}" :title="$t('sidebar.workers')">
									<em class="fas fa-angle-right"></em>
									<span>{{ $t('sidebar.workers') }}</span>
								</router-link>
							</li>

							<li :class="{'active': this.menu !== 'reports' && this.submenu === 'suppliers'}"
								v-if="is_administrator || is_contractor">
								<router-link :to="{name: 'suppliers'}" :title="$t('sidebar.suppliers')">
									<em class="fas fa-angle-right"></em>
									<span>{{ $t('sidebar.suppliers') }}</span>
								</router-link>
							</li>
						</ul>
					</li>

					<li :class="{'active': this.menu === 'notifications'}" v-if="is_administrator"
						@mouseover="notifications_over">
						<router-link :to="{name: 'notifications'}" :title="$t('sidebar.notifications')"
									 @mouseover="notifications_over">
							<em class="icon-envelope-letter" @mouseover="notifications_over"></em>
							<span @mouseover="notifications_over">{{ $t('sidebar.notifications') }}</span>
						</router-link>
					</li>

					<li :class="{'active': this.menu === 'modules'}" v-if="is_administrator">
						<router-link :to="{name: 'modules'}" :title="$t('sidebar.modules')">
							<em class="icon-puzzle"></em>
							<span>{{ $t('sidebar.modules') }}</span>
						</router-link>
					</li>

				</ul>
			</nav>
		</div>
		<div v-show="users_active" @mouseleave="users_leave" v-if="is_aside_toggled || is_aside_toggled">
			<ul class="sidebar-nav sidebar-subnav nav-floating" id="users" style="position: absolute; top: 600px;">
				<li class="sidebar-subnav-header">{{ $t('sidebar.users') }}</li>
				<li :class="{'active': this.submenu === 'workers'}" v-if="is_administrator">
					<router-link :to="{name: 'workers'}" :title="$t('sidebar.workers')">
						<span>{{ $t('sidebar.workers') }}</span>
					</router-link>
				</li>
				<li :class="{'active': this.submenu === 'suppliers'}" v-if="is_administrator || is_contractor">
					<router-link :to="{name: 'suppliers'}" :title="$t('sidebar.suppliers')">
						<span>{{ $t('sidebar.suppliers') }}</span>
					</router-link>
				</li>
			</ul>
		</div>
		<div v-show="setup_active" @mouseleave="setup_leave" v-if="is_aside_toggled || is_aside_toggled">
			<ul class="sidebar-nav sidebar-subnav nav-floating" id="setup" style="position: absolute; top: 323px;">
				<li class="sidebar-subnav-header">{{ $t('sidebar.setup') }}</li>
				<li :class="{'active': this.submenu === 'parts'}" v-if="is_administrator || is_contractor">
					<router-link :to="{name: 'parts'}" :title="$t('sidebar.parts')">
						<span>{{ $t('sidebar.parts') }}</span>
					</router-link>
				</li>
				<li :class="{'active': this.submenu === 'parttypes'}" v-if="is_administrator || is_contractor">
					<router-link :to="{name: 'parttypes'}" :title="$t('sidebar.part-type')">
						<span>{{ $t('sidebar.part-type') }}</span>
					</router-link>
				</li>
				<li :class="{'active': this.submenu === 'producers'}"
					v-if="is_administrator || is_supplier || is_contractor">
					<router-link :to="{name: 'producers'}" :title="$t('sidebar.producers')">
						<span>{{ $t('sidebar.producers') }}</span>
					</router-link>
				</li>
				<li :class="{'active': this.submenu === 'blacklists'}" v-if="is_administrator || is_contractor">
					<router-link :to="{name: 'blacklists'}" :title="$t('sidebar.black-list')">
						<span>{{ $t('sidebar.black-list') }}</span>
					</router-link>
				</li>
				<li :class="{'active': this.submenu === 'warehouses'}" v-if="is_administrator || is_contractor">
					<router-link :to="{name: 'warehouses'}" :title="$t('sidebar.warehouse-list')">
						<span>{{ $t('sidebar.warehouse-list') }}</span>
					</router-link>
				</li>
				<li :class="{'active': this.submenu === 'groups'}" v-if="is_administrator || is_contractor">
					<router-link :to="{name: 'groups'}" :title="$t('sidebar.group-list')">
						<span>{{ $t('sidebar.group-list') }}</span>
					</router-link>
				</li>
				<li :class="{'active': this.menu !== 'setup' && this.submenu === 'admin_product_cat'}"
					v-if="is_administrator || is_contractor">
					<router-link :to="{name: 'admin_product_cat'}" :title="$t('sidebar.categories')">
						<span>{{ $t('sidebar.categories') }}</span>
					</router-link>
				</li>

			</ul>
		</div>

	</aside>
</template>
<script>
	import Userblock from '@/components/Userblock.vue'
	import api from '@/api'

	const getData = (route, next) => {
		const search = route.query.search
		const ordering = route.query.ordering || 'id'
		const page = parseInt(route.query.page) || 1

		Promise.all([
			api.get(`/profile/`),
			api.get(`/supplier_users/?is_admin=false`, {
				params: {
					search: search,
					ordering: ordering,
					page: page
				}
			})
		])
			.then(([profile, users]) => {
				next({
					user: profile.data.results[0],
					supplier: profile.data.results[0].supplier,
					users: users.data.results,
					search: search,
					ordering: ordering,
					pages: users.data.pages,
					count: users.data.count,
					page: page
				})
			})
	}

	export default {
		props: {
			menu: {
				type: String,
				default: ''
			},
			submenu: {
				type: String,
				default: ''
			}
		},
		components: {
			userblock: Userblock
		},
		data() {
			return {
				users_active: false,
				setup_active: false,
				user: {},
				supplier: {},
				users: [],
				errors: {},
				search: null,
				ordering: null,
				pages: null,
				count: null,
				page: null,
				current_password: null,
				new_password: null,
				new_password_2: null
			}
		},
		mounted() {
			this.$i18n.locale = this.$store.getters.language
		},
		computed: {
			is_aside_toggled() {
				return this.$store.getters.aside_collapsed === 'yes'
			},
			supplierId() {
				return localStorage.getItem('etend.supplierId')
			},
			is_aside_collapsed() {
				return this.$store.getters.aside_collapsed === 'yes'
			},
			show_notifications() {
				return this.$store.getters.show_notifications === 'yes'
			},
			show_setup() {
				return this.$store.getters.show_setup === 'yes'
			},
			show_users() {
				return this.$store.getters.show_users === 'yes'
			},
			is_administrator() {
				return this.$store.getters.user_group === 'Administrator'
			},
			get_group() {
				return this.$store.getters.group;
			},
			is_supplier() {
				return this.$store.getters.user_group === 'Supplier'
			},
			is_contractor() {
				return this.$store.getters.user_group === 'Contractor'
			},
			is_master() {
				return this.$store.getters.user_group === 'Master'
			},
			is_not_plain(){
				if(localStorage.getItem('etend.role') != 'PLAIN') {
					return true;
				} else {
					return false;
				}
			}
		},
		methods: {
			users_over: function () {
				this.users_active = true
				this.setup_active = false
			},
			users_leave: function () {
				this.users_active = false
			},
			setup_over: function () {
				this.setup_active = true
				this.users_active = false
			},
			setup_leave: function () {
				this.setup_active = false
			},
			notifications_over: function () {
				this.setup_active = false
				this.users_active = false
			},
			suppliers_over: function () {
				this.users_active = false
				this.setup_active = false
			},
			toggle_setup() {
				this.$store.dispatch('setShowSetup', this.$store.getters.show_setup === 'yes' ? 'no' : 'yes')
			},
			toggle_users() {
				this.$store.dispatch('setShowUsers', this.$store.getters.show_users === 'yes' ? 'no' : 'yes')
			}
		},
		beforeRouteEnter(to, from, next) {
			getData(to, data => {
				next(vm => {
					Object.assign(vm.$data, data)
				})
			})
		},
		beforeRouteUpdate(to, from, next) {
			getData(to, data => {
				Object.assign(this.$data, data)
				next()
			})
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Sidebar.vue